// S3 Configuration for DigitalOcean Spaces
// Automatically detects environment and configures accordingly

const isProduction = import.meta.env.PROD
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
const isDigitalOceanApp = window.location.hostname.includes('ondigitalocean.app')
const isCustomDomain = window.location.hostname === 'methane.uavonic.com'

// Force production mode for DigitalOcean App Platform and custom domain
const isProductionEnvironment = isProduction || isDigitalOceanApp || isCustomDomain

export const S3_CONFIG = {
  // DigitalOcean Spaces endpoint
  endpoint: 'https://fra1.digitaloceanspaces.com',
  region: 'fra1',
  
  // Bucket name
  bucketName: import.meta.env.VITE_DO_SPACES_BUCKET || 'uavonic-methane',
  
  // Credentials (set these in your .env.local file)
  credentials: {
    accessKeyId: import.meta.env.VITE_DO_SPACES_ACCESS_KEY,
    secretAccessKey: import.meta.env.VITE_DO_SPACES_SECRET_KEY
  }
}

// Environment detection
export const getEnvironmentInfo = () => {
  const hostname = window.location.hostname
  
  return {
    isProduction,
    isLocalhost,
    isDigitalOceanApp,
    isCustomDomain,
    hostname,
    shouldEnableS3: isProductionEnvironment && !isLocalhost
  }
}

// Validate configuration
export const validateS3Config = () => {
  const errors = []
  const envInfo = getEnvironmentInfo()
  
  // Debug logging (disabled in production)
  if (import.meta.env.DEV) {
    console.log('S3 Config Debug:', {
      environment: envInfo,
      shouldEnableS3: envInfo.shouldEnableS3,
      reason: envInfo.isLocalhost ? 'localhost' : envInfo.shouldEnableS3 ? 'production' : 'unknown'
    })
  }
  
  // Skip validation for localhost development
  if (envInfo.isLocalhost) {
    console.log('S3 upload disabled for localhost development')
    return {
      isValid: false,
      errors: ['S3 upload disabled for localhost development'],
      reason: 'localhost'
    }
  }
  
  // Enable S3 for production environments
  if (envInfo.shouldEnableS3) {
    console.log('S3 upload enabled for production environment:', envInfo.hostname)
    // For production, we still need to validate credentials
  } else {
    console.log('S3 upload disabled - not a production environment')
    return {
      isValid: false,
      errors: ['S3 upload disabled - not a production environment'],
      reason: 'not_production'
    }
  }
  
  if (!S3_CONFIG.credentials.accessKeyId) {
    errors.push('VITE_DO_SPACES_ACCESS_KEY is required')
  }
  
  if (!S3_CONFIG.credentials.secretAccessKey) {
    errors.push('VITE_DO_SPACES_SECRET_KEY is required')
  }
  
  return {
    isValid: errors.length === 0,
    errors,
    reason: errors.length > 0 ? 'missing_credentials' : 'valid'
  }
}

// Instructions for setting up environment variables
export const SETUP_INSTRUCTIONS = `
To enable S3 upload functionality, create a .env.local file in your project root with:

VITE_DO_SPACES_ACCESS_KEY=your_access_key_here
VITE_DO_SPACES_SECRET_KEY=your_secret_key_here
VITE_DO_SPACES_BUCKET=uavonic-methane

You can get these credentials from:
1. DigitalOcean Control Panel
2. Go to API > Spaces Keys
3. Generate new key or use existing one
`
